export default __webpack_public_path__ + "static/media/box1-ar.0ee716bc.svg";